// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cdfc27e8","455":"5899359f"}[chunkId] + ".chunk.js";
};